import React, { useEffect, useState } from "react";
import services from "../../services";

let combolistrequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: false,
    Page: 2,
    PageSize: 2,
};

const LocationFunction = ({
    distrito_id,
    country_id,
    fregusia_id,
    getLocationData,
}) => {
    const [form, setForm] = useState({
        distrito_id: "0",
        country_id: "0",
        fregusia_id: "0",
    });
    const [busentDistrito, setBusentDistrito] = useState([]);
    const [busentConcelho, setBusentConcelho] = useState([]);
    const [BusEntFreguesia, setBusEntFreguesia] = useState([]);

    const getDistritoList = async () => {
        try {
            let busentdistrito = await services.apiCall.requestApi(
                "/busentdistrito/GetAll/",
                combolistrequest,
                "post"
            );
            console.log("value in the location ", busentdistrito);
            if (busentdistrito) {
                setBusentDistrito(busentdistrito);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getCancelList = async (id) => {
        try {
            let busentconcelho = await services.apiCall.requestApi(
                "/busentconcelho/getbyid/" + id,
                {},
                "post"
            );
            if (busentconcelho) {
                setBusentConcelho(busentconcelho);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getFregList = async (id) => {
        try {
            let reqData = {
                districtId: +form.distrito_id || +distrito_id,
                countryId: +id,
            };
            console.log("9990 reqData ", reqData);
            let BusEntFreguesia = await services.apiCall.requestApi(
                "/BusEntFreguesia/GetByID",
                reqData,
                "post"
            );
            if (BusEntFreguesia) {
                setBusEntFreguesia(BusEntFreguesia);
            }
        } catch (error) {}
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "distrito_id") {
            getCancelList(+value);
            setForm({
                [name]: value,
                country_id: "0",
                fregusia_id: "0",
            });
        }
        if (name === "country_id") {
            getFregList(+value);
            setForm({
                ...form,
                [name]: value,
                fregusia_id: "0",
            });
        }
        if (name === "fregusia_id") {
            setForm({
                ...form,
                [name]: value,
            });
        }
        getLocationData(name, value);
    };

    useEffect(() => {
        getDistritoList();
    }, []);
    useEffect(() => {
        if (distrito_id && fregusia_id && country_id) {
            getDistritoList();
            getFregList(+country_id);
            getCancelList(+distrito_id);
            setForm({
                distrito_id,
                fregusia_id,
                country_id,
            });
        }
    }, [distrito_id, fregusia_id, country_id]);
    return (
        <>
            <div className="pr-0 col-md-4">
                <div className="input-box active-grey drop-down-box">
                    <label className="input-label">Distrito </label>
                    <select
                        className="custome-drop-down"
                        onChange={(e) => handleChange(e)}
                        name="distrito_id"
                        value={form.distrito_id || ""}
                        id="Distrito"
                    >
                        <option value="">Selecione Distrito </option>
                        {busentDistrito &&
                            busentDistrito.map((el, index) => (
                                <option value={el.coddis} key={index}>
                                    {el.desdis}
                                </option>
                            ))}
                    </select>
                </div>
            </div>
            <div className="pr-0 col-md-4">
                <div className="input-box active-grey drop-down-box">
                    <label className="input-label">Concelho</label>
                    <select
                        className="custome-drop-down"
                        onChange={(e) => handleChange(e)}
                        name="country_id"
                        value={form.country_id || ""}
                        id="Concelho"
                    >
                        <option value="">Selecione Concelho</option>
                        {busentConcelho &&
                            busentConcelho.map((el, index) => (
                                <option value={el.codcon} key={index}>
                                    {el.descon}
                                </option>
                            ))}
                    </select>
                </div>
            </div>
            <div className="col-md-4">
                <div className="input-box active-grey drop-down-box">
                    <label className="input-label">Freguesia </label>
                    <select
                        className="custome-drop-down"
                        onChange={(e) => handleChange(e)}
                        name="fregusia_id"
                        value={form.fregusia_id || ""}
                        id="Freguesia"
                    >
                        <option value="">Selecione Freguesia </option>
                        {BusEntFreguesia &&
                            BusEntFreguesia.map((el, index) => (
                                <option value={el.codfrg} key={index}>
                                    {el.desfrg}
                                </option>
                            ))}
                    </select>
                </div>
            </div>
        </>
    );
};

export default LocationFunction;
